import './PhoneCallStatus.scss';

export type PhoneCallStatus =
  | 'REQUESTED'
  | 'QUEUED'
  | 'RINGING'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'FAILED'
  | 'NO_ANSWER'
  | 'BUSY'
  | 'CANCELED';

interface PhoneCallStatusProps {
  status: string;
  className?: string;
}

const statusConfig: Record<PhoneCallStatus, {
  label: string;
  icon: string;
  variant: 'primary' | 'info' | 'success' | 'warning' | 'danger' | 'secondary';
}> = {
  REQUESTED: {
    label: 'Requested',
    icon: 'schedule',
    variant: 'secondary',
  },
  QUEUED: {
    label: 'Queued',
    icon: 'hourglass_empty',
    variant: 'info',
  },
  RINGING: {
    label: 'Ringing',
    icon: 'phone_in_talk',
    variant: 'primary',
  },
  IN_PROGRESS: {
    label: 'In Progress',
    icon: 'phone_in_talk',
    variant: 'primary',
  },
  COMPLETED: {
    label: 'Completed',
    icon: 'check_circle',
    variant: 'success',
  },
  FAILED: {
    label: 'Failed',
    icon: 'error',
    variant: 'danger',
  },
  NO_ANSWER: {
    label: 'No Answer',
    icon: 'phone_missed',
    variant: 'warning',
  },
  BUSY: {
    label: 'Busy',
    icon: 'phone_busy',
    variant: 'warning',
  },
  CANCELED: {
    label: 'Canceled',
    icon: 'cancel',
    variant: 'secondary',
  },
};

export function PhoneCallStatus({ status, className = '' }: PhoneCallStatusProps) {
  const config = statusConfig[status as PhoneCallStatus] || {
    label: status,
    icon: 'help',
    variant: 'secondary' as const,
  };

  return (
    <span className={`phone-call-status badge bg-${config.variant} ${className}`}>
      {config.label}
    </span>
  );
}
